import { SubmitHandler, useForm } from 'react-hook-form'

import { useServerBilling } from '@/api/useServerBilling'
import Select from '@/components/forms/Select'
import Button from '@/components/misc/Button'
import { SelectInterface } from '@/interfaces/InterfacesLocal'
import { RegisterBillingInterface } from '@/interfaces/ServerInterfaces'
import { useAppSelector } from '@/store/hooks'

export const DispatchSelectedModal = ({
  registerBillingList,
  refreshList,
}: {
  registerBillingList: RegisterBillingInterface[]
  refreshList: () => void
}) => {
  const { areas } = useAppSelector((state) => state.nomenclator)
  const { business } = useAppSelector((state) => state.init)
  const areasSelect: SelectInterface[] = areas
    .filter((item) => item.type === 'SALE')
    .map((item) => ({ id: item.id, name: item.name }))
  const { handleSubmit, control } = useForm()
  const precision = Number(
    business?.configurationsKey.find(
      (item) => item.key === 'precission_after_coma'
    )?.value
  )
  const {
    sendPredispatchSelected,
    isFetching,
    sendCalculateCubaje,
    isLoading,
    cubajeDetails,
  } = useServerBilling()
  const preDispatchedList = registerBillingList.filter(
    (item) => !item.isPreDispatched && item.isPreReceipt
  )

  const comp = (amountDispatches: number, amountOrdersMove: number) => (
    <div>
      Predespachos enviados correctamente <br />
      Prefacturas procesadas: {amountOrdersMove} <br />
      Productos predespachados: {amountDispatches}
    </div>
  )
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
    const { saleArea } = data
    sendPredispatchSelected(
      Number(saleArea),
      preDispatchedList.map((item) => item.id),
      comp,
      () => refreshList()
    )
  }
  const onClickDetailsButton = () => {
    sendCalculateCubaje(preDispatchedList.map((item) => item.id))
  }
  return (
    <div>
      <h2 className="mb-2 text-left text-xl font-semibold text-slate-600">
        {'Predespachar selección'}
      </h2>
      <form className={'flex flex-col'} onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 grid grid-cols-1 gap-5">
          <Select
            control={control}
            data={areasSelect}
            label="Área de venta"
            name="saleArea"
            rules={{ required: 'Este campo es requerido' }}
          />

          <h3
            className={
              'text-sm font-medium text-gray-700 first-letter:uppercase'
            }
          >
            Cantidad de prefacturas seleccionadas: {preDispatchedList.length}
          </h3>
        </div>

        <div className="mt-5 w-full">
          <Button
            action={() => onClickDetailsButton()}
            className={'border-2 border-slate-600'}
            color="white"
            disabled={isLoading}
            full
            loading={isLoading}
            name={'Detalles'}
            outline
            textColor={'slate-900'}
          />
        </div>

        {cubajeDetails && (
          <div className={'mt-5'}>
            <p
              className={
                'text-sm font-medium text-gray-700 first-letter:uppercase'
              }
            >
              Cantidad de ítems:{' '}
              <span className={'font-semibold'}>
                {cubajeDetails.amountProducts}
              </span>
            </p>
            <p
              className={
                'text-sm font-medium text-gray-700 first-letter:uppercase'
              }
            >
              Cubicaje total:{' '}
              <span className={'font-semibold'}>
                {Number(cubajeDetails.totalCubaje).toFixed(precision)} m&sup3;
              </span>
            </p>
          </div>
        )}

        <div className="mt-8 w-1/2 self-end">
          <Button
            color="slate-600"
            disabled={isFetching || preDispatchedList.length === 0}
            full
            loading={isFetching}
            name={'Aceptar'}
            type="submit"
          />
        </div>
      </form>
    </div>
  )
}
